import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { GetDataPromise } from "../Functions/SendingData";
import { apiMain } from "../../App";
import CarouselMain from "./CarouselMain";
import { Link, useParams, useLocation } from "react-router-dom";

const Styles = styled.div`
  margin-top: 30px;
  h2 {
    width: 100px;
    text-align: center;
    margin: 0 auto 10px;
    color: var(--prime-1);
  }

  ul {
    display: flex;
    justify-content: center;
    gap: 20px;
    list-style: none;
    padding: 0;
  }

  li {
    width: 100px;
    height: 30px;
    background-color: white;
    padding: 8px 10px;
    border: 1px solid #ccc;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    cursor: pointer;
  }

  li.selected {
    background-color: var(--prime-1);
    color: white;
  }

  .countries ul {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    padding: 0;
    list-style: none;
  }

  .countries li {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 160px;
    height: 140px;
    padding: 10px;
    background-color: #f9f9f9;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    gap: 10px;
  }

  .countries img {
    width: 150px;
    height: 90px;
    object-fit: cover;
    border-radius: 8px;
    margin-bottom: 10px;
  }

  .countries span {
    font-size: 14px;
    font-weight: bold;
    color: #333;
  }

  .countries {
    padding: 0 var(--universal-pad);
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin: 0 auto;
  }
  .linkk {
    text-decoration: none;
    color: #333;
  }
`;

export default function CountryFilterBroker35(props) {
  const { lan } = props;
  const { continent: continentFromUrl } = useParams();
  const [continents, setContinents] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedContinent, setSelectedContinent] = useState(null);
  const [loadingContinents, setLoadingContinents] = useState(false);
  const [loadingCountries, setLoadingCountries] = useState(false);
  const location = useLocation();

  const getContinents = async () => {
    setLoadingContinents(true);
    try {
      const res = await GetDataPromise(`${apiMain}/api/v1/setting/continent`);
      const parsed = JSON.parse(res);
      if (parsed.status === "success" && parsed.data) {
        setContinents(parsed.data);

        if (parsed.data.length > 0) {
          const initialContinent =
            parsed.data.find(
              (continent) => continent.Continent_Url === continentFromUrl
            ) || parsed.data[0];

          setSelectedContinent(initialContinent.Continent_Url);
          fetchCountries(initialContinent.Continent_Id);
        }
      }
    } catch (error) {
      console.error("Error fetching continents:", error);
    } finally {
      setLoadingContinents(false);
    }
  };

  const fetchCountries = async (continentId) => {
    setLoadingCountries(true);
    try {
      const res = await GetDataPromise(
        `${apiMain}/api/v1/setting/country/select_country?Continent_Id=${continentId}`
      );
      const parsed = JSON.parse(res);
      if (parsed.status === "success" && parsed.data) {
        setCountries(parsed.data);
      } else {
        setCountries([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setLoadingCountries(false);
    }
  };

  useEffect(() => {
    getContinents();
  }, []);

  const handleSelect = (continentUrl) => {
    setSelectedContinent(continentUrl);
    const selectedContinent = continents.find(
      (continent) => continent.Continent_Url === continentUrl
    );
    if (selectedContinent) {
      fetchCountries(selectedContinent.Continent_Id);
    }
  };

  const makeCarts = () => {
    return countries.map((country) => {
      // تشخیص اینکه از کدام صفحه استفاده کنیم (tour-operator یا travel-agency)
      const pageType = location.pathname.includes("tour-operator")
        ? "tour-operator"
        : "travel-agency"; // اگر در URL tour-operator وجود داشته باشد، از آن استفاده می‌کند

      return (
        <li key={country.Country_Id}>
          <Link
            className="linkk"
            to={`/${lan.filename}/${pageType}/${selectedContinent}/${country.Country_Url}`}
          >
            {country.Country_Image ? (
              <img src={country.Country_Image} alt={country.Country_En_Name} />
            ) : null}
            <span>
              {lan.filename === "fa"
                ? country.Country_Name
                : country.Country_En_Name}
            </span>
          </Link>
        </li>
      );
    });
  };

  return (
    <Styles>
      <h2>{lan.filename === "fa" ? "قاره‌ها" : "Continents"}</h2>

      {loadingContinents ? (
        <p>{lan.filename === "fa" ? "در حال بارگذاری..." : "Loading..."}</p>
      ) : (
        <ul>
          {continents.map((continent) => (
            <li
              key={continent.Continent_Id}
              className={
                selectedContinent === continent.Continent_Url ? "selected" : ""
              }
              onClick={() => handleSelect(continent.Continent_Url)}
            >
              <div>
                <strong>
                  {lan.filename === "fa"
                    ? continent.Continent_FaName
                    : continent.Continent_EnName}
                </strong>
              </div>
            </li>
          ))}
        </ul>
      )}

      <div className="countries">
        {loadingCountries ? (
          <p>{lan.filename === "fa" ? "در حال بارگذاری..." : "Loading..."}</p>
        ) : countries.length > 0 ? (
          <CarouselMain lan={lan}>{makeCarts()}</CarouselMain>
        ) : (
          <p>
            {lan.filename === "fa" ? "کشوری یافت نشد." : "No countries found."}
          </p>
        )}
      </div>
    </Styles>
  );
}